import { FrameName } from "../config";
import SettlementEmptyTerrainTileEntity from "./SettlementEmptyTerrainTileEntity";

class SettlementEmpty12TerrainTileEntity extends SettlementEmptyTerrainTileEntity {
	public static readonly frameName = FrameName.SETTLEMENT_EMPTY12;
}

export default SettlementEmpty12TerrainTileEntity;
